import {
  SESSION_DETAILS_SECTIONS_PROPS,
  SimDataProps,
} from 'src/common/components/Sim/Details/constants/sections';
import { RSimInventoryItem } from 'src/rSimInventory/constants/rsim';

type RimDataProps = (keyof RSimInventoryItem)[];

export const RSIM_PROFILES_SECTION_PROPS: RimDataProps = [
  'status',
  'lastPollingTimestamp',
  'isCustomConfigurationDetected',
  'isPendingConfiguration',
  'appliedOtaConfigurationProfile',
  'euicc',
  'iccidOta',
];

export const RSIM_CLIENT_SECTION_PROPS: RimDataProps = ['accountName', 'accountNumber'];

export const RSIM_USAGE_IN_CYCLE_SECTION_PROPS: RimDataProps = [
  'dataUsage',
  'inMinuteUsage',
  'inTextUsage',
  'outMinuteUsage',
  'outTextUsage',
];

export const RSIM_SIM_LAST_SESSION_SECTION_PROPS: SimDataProps = [
  ...SESSION_DETAILS_SECTIONS_PROPS,
  'cumulativeTotalUsage',
  'ratType',
];
